import { inject, Injectable } from '@angular/core';
import { FormFunctionResult, WdxDestroyClass } from '@wdx/shared/utils';
import { catchError, delay, Observable, of, tap } from 'rxjs';
import { FormProcessConditionDataService } from '../../services';
import { FormFieldsDataService } from '../form-fields-data';
import { FormGroup } from '@angular/forms';

@Injectable()
export class FormApiFunctionService extends WdxDestroyClass {
    private formProcessService = inject(FormProcessConditionDataService);
    private formFieldsDataService = inject(FormFieldsDataService);

    private functionQueue: {
        fieldsToNullCheck: string[];
        form: FormGroup;
        invokeFunction$: (
            formData: any,
        ) => Observable<null | FormFunctionResult>;
    }[] = [];

    public queueFunction(
        formId: string,
        fieldsToNullCheck: string[],
        form: FormGroup,
        functionName: string,
        callback: (result: FormFunctionResult, functionName: string) => void,
        subFormName?: string,
        subFormIndex?: number,
        isSubform?: boolean,
    ): void {
        const functionCall = {
            fieldsToNullCheck,
            form,
            invokeFunction$: (formData: any) =>
                this.formProcessService
                    .getApiFunctionTrigger(
                        {
                            formId,
                            formValue: formData,
                        },
                        functionName,
                        subFormName,
                        subFormIndex,
                        isSubform,
                    )
                    .pipe(
                        catchError(() => of(null)),
                        tap((result) => {
                            if (result) {
                                callback(result, functionName);
                            }
                            this.triggerNextFunctionInQueue();
                        }),
                    ),
        };
        this.functionQueue.push(functionCall);
        if (this.functionQueue.length === 1) {
            this.functionQueue[0]
                .invokeFunction$(
                    this.formFieldsDataService.parseFormData(
                        this.functionQueue[0].fieldsToNullCheck,
                        this.functionQueue[0].form,
                    ),
                )
                .pipe(delay(0))
                .subscribe();
        }
    }

    private triggerNextFunctionInQueue(): void {
        this.functionQueue.shift();
        if (this.functionQueue.length) {
            this.functionQueue[0]
                .invokeFunction$(
                    this.formFieldsDataService.parseFormData(
                        this.functionQueue[0].fieldsToNullCheck,
                        this.functionQueue[0].form,
                    ),
                )
                .pipe(delay(0))
                .subscribe();
        }
    }
}
